import AdministrationTypes from "Containers/Administration/types"

const initialState = {
  organigramme: {},
  users_business: [],
  profils_business: [],
}

const AdministrationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AdministrationTypes.GET_ORGANIGRAMME_SUCCESS:
      return {
        ...state,
        organigramme: payload,
      }
    case AdministrationTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        users_business: payload?.body || [],
      }
    case AdministrationTypes.GET_PROFILS_SUCCESS:
      return {
        ...state,
        profils_business: payload?.body || [],
      }
    default:
      return state
  }
}

export default AdministrationReducer
